module.exports = __webpack_public_path__ + "img/product.a2b9a7a2.png";